import { configure } from '@testing-library/react';

configure({ testIdAttribute: 'data-hook' });
